import {RouteView, PageView} from '../layouts'
import {operation} from './operation'
import {mall} from './mall'
import {system} from './system'
import {user} from './user'
import {bigConsumer} from './bigConsumer'
import {community} from "./community";
// import {member} from "./member";
import {service} from "./service";
import {sales} from "./sales";
import {writeoff} from "./writeoff";
import {im} from "./im";
import {exception} from "./exception";
import {invitedRecord} from "./invitedRecord"
import {active} from "./active"
import {parameter} from './parameter'
import {skin} from './skin'
import {integral} from './integral'
import { vote } from './vote'
import {directSeeding} from './directSeeding'
import {tduck} from './tduck'
import {qa} from './questionAndAnswer'
import {zone} from './zone'
// import {member} from "./member";
// const ctx = require.context('./', true, /\.js$/)
// console.log(ctx)
// let routerObj = {}
// for (const key of ctx.keys()) {
//     if (key == './router.config.js' || key=='./member') {
//         continue;
//     } else {
//         // map[keyArr.join('.').replace(/\.js$/g, '')] = ctx(key)
//         routerObj = Object.assign(routerObj,ctx(key))
//     }
// }
// let routerArr = []
// for (let k in routerObj) {
//     routerArr.push(routerObj[k])
// }
 let asyncRouterMap= [
    {
        path: '/',
        name: 'main',
        component: resolve => require(['../layouts/basic.vue'], resolve),
        meta: {title: '首页'},
        redirect: '/workplace',
        children: [
            {
                path: '/workplace',
                meta: {title: "欢迎登录"},
                component: () => import('../views/home/workplace.vue'),
            },
            {
                path: '/admin/info',
                meta: {title: "个人信息"},
                component: () => import('../views/admin/info.vue'),
            },
            // ...routerArr
            system,
            // 系统参数
            parameter,
            user,
            zone,
            operation,
            tduck,
            qa,
            mall,
            community,
            sales,
            service,
            // member,
            writeoff,
            directSeeding,
            im,
            invitedRecord,
            exception,
            // 10月末上线活动【需隐藏】--------------------------------
            active,
            //------------------------------------------
            // 皮肤补丁包
            skin,
            integral,
            // 投票活动
            vote,
            bigConsumer
        ]
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/admin/login.vue'),
        meta: {title: '用户登录', keepAlive: false}
     },
     {
        path: '/questionnaire/:key',
        meta: {requireLogin: false,title: '问卷'},
        component: () => import(/* webpackChunkName: 'root' */ '@/views/tduck/write')
    },
    {
        path: '*', redirect: '/exception/404', hidden: true,
    },

 ];
export default asyncRouterMap;
